import type { PluginWithOptions, Token } from "markdown-it"
import Renderer from "markdown-it/lib/renderer"

const openRe = /^-{3}\s*$/
const closeRe = /^(?:\.{3}|-{3})\s*$/

interface MetadataOptions {
  parseMetadata: (src: string) => any,
  meta?: object
}

export const metadata_block: PluginWithOptions<MetadataOptions> = (md,options) => {  
  md.block.ruler.before('table','metadata_block',(state,startLine,endLine,silent) => {
    if (!state.env.meta) state.env.meta = options?.meta || {}
    const opener = state.getLines(startLine,startLine + 1,0,false)
    if (openRe.test(opener) && (startLine == 0 || state.isEmpty(startLine - 1))) {
      const nextLines = state.getLines(startLine + 1,endLine,0,false).split('\n')
      const end = nextLines.findIndex(x => closeRe.test(x))
      if (end >= 0) {
        try {
          const content = nextLines.slice(0,end).join('\n')
          const val = options?.parseMetadata(nextLines.slice(0,end).join('\n'))
          if (typeof val == 'object') {
            if (silent) return true                
            Object.assign(state.env.meta,val)
            const token = state.push('metadata_block','',0)
            token.meta = Object.entries(val).map(([k,v]) => ([k, md.parseInline(`${v}`, state.env)]));
            token.markup = "---"
            token.content = state.getLines(startLine + 1, startLine + 1 + end,0,false)
            state.line =  startLine + end + 2
            return true
          }
        } catch (e) { // invalid yaml is ignored
          return false
        }
      }
    }
    return false
  })

  md.renderer.rules['metadata_block'] = (tokens: Token[], idx: number, options: markdownit.Options, env: any, self: Renderer) => {
    var x= (tokens[idx].meta as [string,Token[]][]).map(([k,v]) => '<small><b style="padding: 0 6px;">' + k + ':</b> '+self.render(v,options,env)+'</small>').join('<br>');
    return x;
  };
}

